<template>
    <div id="labels">
        <div id="forest_label">
            <p id="forest_text">Forest</p>
        </div>
        <div id="traditional_label">
            <p id="traditional_text">Traditional</p>
        </div>
    </div>
    <div id="graphs">
        <div id="forest_graph_sp">
            <div class="times">
                <svg class="times_svg">
                   <text class="time_label_left" x="35%" y="3%">8:30 am</text> 
                   <line class="timeline" x1="35%" y1=".5%" x2="97%" y2=".5%"/>
                   <text class="time_label_left" x="35%" y="47%">Half Day</text> 
                   <line class="timeline" x1="35%" y1="48%" x2="97%" y2="48%"/>
                   <text class="time_label_left" x="35%" y="50.5%">Option</text> 
                   <text class="time_label_left" x="35%" y="98%">4:30 pm</text> 
                   <line class="timeline" x1="35%" y1="99%" x2="97%" y2="99%"/>
                </svg>
            </div>
            <div class="activities">
            <div v-for="(act,index) in sched_forest"
                :key="act.Activity"
                class="sched_rect"
            ><p id="act" 
                :class="act.Type"
                :style="height_f(act.Time,index)">{{act.Activity}}</p>
            </div>
            </div>
        </div>
        <div class="notes">
            <p id="notes">Forest Kindergarten is 100% outside</p>
            <p id="legend2">Static Activities</p>
            <p id="legend4">Mobile Activities</p>
        </div>
        <div id="traditional_graph_sp">
            <div class="activities">
            <div v-for="(act,index) in sched_trad"
                :key="act.Activity"
                class="sched_rect"
            ><p id="act"
                :class="act.Type"
                :style="height_t(act.Time,index)">{{act.Activity}}</p>
            </div>
            </div>
            <div class="times">
                <svg class="times_svg">
                   <text class="time_label_right" x="65%" y="3%">8:30 am</text> 
                   <line class="timeline" x1="3%" y1=".5%" x2="65%" y2=".5%"/>
                   <text class="time_label_right" x="65%" y="90.5%">2:30 pm</text> 
                   <line class="timeline" x1="3%" y1="91.5%" x2="65%" y2="91.5%"/>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import programs from '../assets/programs.json'
import { scaleLinear } from 'd3-scale';

export default {
  name: 'programs',
  data() {
    return {
      sched_forest: programs[0].Schedule,
      sched_trad: programs[1].Schedule
    }
  },
  computed: {
     
  },
  methods: { 
      height_f: function(value,index) {
         if (index+1 < this.sched_forest.length){
              const h = scaleLinear()
                  .domain([10, 100])
                  .range([10, 60]);
          return "padding:" + h(this.sched_forest[index+1].Time - value)/3.3+"px"
          } else {
            const h = scaleLinear()
                  .domain([10, 100])
                  .range([10, 60]);
            return "padding:" + h(1630 - value)/3.3+"px"
          } 
      },
      height_t: function (value, index) {
          if (index+1 < this.sched_trad.length){
              const h = scaleLinear()
                  .domain([10, 100])
                  .range([10, 60]);
          return "padding:" + h(this.sched_trad[index+1].Time - value)/3.3+"px"
          } else {
            const h = scaleLinear()
                  .domain([10, 100])
                  .range([10, 60]);
            return "padding:" + h(1430 - value)/3.3+"px"
          }
      }
  },
  components: {
  },
  setup() {
  }
}
</script>

<style>

#forest_graph_sp, #traditional_graph_sp {
    height: 100%;
    width:38%;
    float: left;
}

#forest_graph_sp {
    padding-left: 2%;
}

#traditional_graph_sp>.activities {
    margin-left: 12%;
}

#schedule {
    width:100%;
    height:920px;
}

.time_label_right {
    fill: white;
    font-family: Josefin;
    text-anchor:end;
    font-size: 1.2vw;
}

.time_label_left {
    fill: white;
    font-family: Josefin;
    text-anchor:start;
    font-size: 1.2vw;
}


#act {
    text-align:center;
    font-size: 1.5vw;
    font-family: Josefin;
    padding-top: 2%;
    padding-bottom: 2%;
    color:white;
    margin-top: 0px;
    margin-bottom: 2%;
}

#act, #legend2, #legend4 {
    border-radius: 5px;
    border-style: solid;
    border-width: 1px;
    border-color:white;
}

.times_svg {
    width: 100%;
    height: 725px;
}

.notes {
    float: left;
    width: 20%;
    height: 845px;
}

#notes, #legend2, #legend4 {
    text-align:center;
    font-family: Josefin;
    color:white;
}

#notes {
    margin-top: 270px;
    font-size: 1.5vw;
}

#legend2, #legend4 {
    margin-right: 20%;
    margin-left: 20%;
    font-size: 1.2vw;
    margin-top: 15px;
    padding: 10px 0px 10px 0px;
}

#legend4 {
    background-color: #46755280;
}

#legend2 {
    background-color: #80644380;
}

.activities {
    float:left;
    width: 60%;
}

.times {
    float:left;
    height: 100%;
}

#forest_graph_sp>.times{
    width: 30%;
}

#traditional_graph_sp>.times{
    width: 25%;
}

.timeline {
    stroke:white;
    stroke-width:1;
}

.active {
    background-color: #46755280;
}

.sedentary {
    background-color: #80644380;
}
</style>
